import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import styled from "@emotion/styled";

import Button from "../../components/Atoms/Button";
import Txt from "../../components/Atoms/Txt";
import { BREAKPOINTS } from "../configs/consts";
import cookie from "../../assets/cookie.png";
import settings from "../../assets/settings.png";

const PrivacyCookiesPolicy = (props) => {
  const [cookieItens, setCookieItens] = useState([
    {
      name: "Funcional",
      description:
        "Esse cookie é utilizado para armazenar as preferências de cookies do usuário, garantindo que as escolhas feitas sejam respeitadas em visitas futuras ao site.",
      alweysActive: true,
    },
    {
      key: "_ga",
      name: "Cookies de Estatísticas",
      description: "Esses cookies são utilizados pelo Google Analytics 4 para coletar informações anônimas sobre como os visitantes usam o site. Eles ajudam a entender dados como número de acessos, tempo de permanência, páginas visitadas e fluxo de navegação. Essas informações nos ajudam a melhorar a experiência do usuário. Nenhum dado pessoal é coletado ou compartilhado.",
      active: true,
    }
  ]);

  const { config } = props;
  const [isVisible, setIsVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const cookieConsent = Cookies.get("cookieConsent");

  const handleAccept = () => {
    if (open) {
      const itensToSave = cookieItens.reduce((acc, curr) => {
        if (curr.key && curr.active) {
          acc.push(curr.key);
        }
  
        return acc
      }, []);

      Cookies.set("cookieConsent", itensToSave.length > 0 ? itensToSave : "declined", { expires: 365 });
      clearCookies();
    } else {
      Cookies.set("cookieConsent", "accepted", { expires: 365 });
    }

    setIsVisible(false);
  };

  const handleDecline = () => {
    Cookies.set("cookieConsent", "declined", { expires: 365 });
    clearCookies();
    setIsVisible(false);
  };

  const clearCookies = () => {
    const allCookies = Cookies.get();

    const hostname = window?.location?.hostname;

    const domainParts = hostname.split(".");
    const possibleDomains = [];

    for (let i = 0; i < domainParts?.length - 1; i++) {
      const domain = domainParts.slice(i).join(".");
      possibleDomains.push(domain);
      possibleDomains.push("." + domain);
    }

    Object.keys(allCookies).forEach((cookieName) => {
      if (cookieName !== "cookieConsent") {
        if (cookieConsent === "declined") {
          Cookies.remove(cookieName);
  
          possibleDomains.forEach((domain) => {
            Cookies.remove(cookieName, { domain });
            Cookies.remove(cookieName, { domain, path: "/" });
          });
        } else if (cookieConsent !== "accepted" && cookieConsent?.split(",")?.length > 0) {
          const acceptedCookies = cookieConsent?.split(",") || [];

          const isWhiteListed = acceptedCookies.some(
            (acceptedCookie) => cookieName === acceptedCookie || cookieName.startsWith(acceptedCookie)
          );
                
          if (!isWhiteListed) {
            Cookies.remove(cookieName);
  
            possibleDomains.forEach((domain) => {
              Cookies.remove(cookieName, { domain });
              Cookies.remove(cookieName, { domain, path: "/" });
            });
          }
        } 
      }
    });
  };

  const randerCookieItem = (item, index) => {
    return (
      <div key={index} className="cookie-item">
        <Txt typo="subtitle-md" align="left" className="cookie-item-title">
          {item.name}

          {item.alweysActive ? (
            <span className="always-active">Sempre ativo</span>
          ) : (
            <button
              className={item.active ? "active" : "inactive"}
              onClick={() => {
                setCookieItens((values) => {
                  const newValues = [...values];
                  newValues[index].active = !newValues[index].active;

                  return newValues;
                });
              }}
            >
              <div />
            </button>
          )}
        </Txt>
        <p>{item.description}</p>
      </div>
    );
  };

  useEffect(() => {
    if (!cookieConsent) {
      setIsVisible(true);
    }

    let lastCookieSnapshot = document?.cookie;
    let intervalId;

    if (cookieConsent === "declined" || (cookieConsent != "accepted" && cookieConsent?.split(",")?.length > 0)) {
      setTimeout(() => {
        clearCookies();
      }, 500);

      intervalId = setInterval(() => {
        const currentCookieSnapshot = document?.cookie;

        if (currentCookieSnapshot !== lastCookieSnapshot) {
          lastCookieSnapshot = currentCookieSnapshot;
          clearCookies();
        }
      }, 20000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [cookieConsent]);

  useEffect(() => {
    if (open) {
      setCookieItens((values) => {
        return values.map((item) => ({
          ...item,
          active: true,
        }));
      });
    }
  }, [open]);

  return (
    isVisible && (
      <StyledContainer config={config} open={open}>
        {!open ? (
          <section className="left-section">
            <Txt typo="subtitle-xl" align="left" className="left-section-Title">
              <img src={cookie} /> Preferências de Cookies
            </Txt>
            <p className="left-section-message">
              Usamos cookies para garantir que você obtenha a melhor experiência
              no nosso site.
              Acesse nossa{" "}
              <a
                href="https://cruzeiro-website-project-documents.s3.us-east-1.amazonaws.com/Documentos+obrigat%C3%B3rios+SITE/POL%C3%8DTICA+DE+PRIVACIDADE/politicadeprivacidade1507_cruzeirosaf.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Política de Privacidade
              </a>
              {" "} e nossa{" "}
              <a
                href="https://cruzeiro-website-project-documents.s3.us-east-1.amazonaws.com/Documentos+obrigat%C3%B3rios+SITE/POL%C3%8DTICA+DE+PRIVACIDADE/politicadecookies1507_cruzeirosaf.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Política de Cookies
              </a> para mais informações.
            </p>
          </section>
        ) : (
          <section className="left-section">
            <Txt typo="subtitle-xl" align="left" className="left-section-Title">
              <img src={cookie} /> Preferências de Cookies
              <div className={"close-button"} onClick={() => setOpen(false)}>
                &times;
              </div>
            </Txt>
            <p className="left-section-message">
              Utilizamos cookies para ajudar você a navegar com eficiência e
              executar certas funções. Você encontrará informações detalhadas
              sobre todos os cookies sob cada categoria de consentimento abaixo.
            </p>

            <div>{cookieItens.map(randerCookieItem)}</div>
          </section>
        )}
        <section className="right-section">
          {!open && (
            <Button className="btn-settings" onClick={() => setOpen(true)}>
              <img src={settings} alt="Settings" />
            </Button>
          )}
          <Button
            className="interact-button right-button"
            onClick={handleDecline}
          >
            <Txt typo="tag-button-lg" className="interact-button-text">
              rejeitar
            </Txt>
          </Button>
          <Button className="interact-button" onClick={handleAccept}>
            <Txt typo="heading-sm" className="interact-button-text">
              {open ? "salvar preferências" : "Aceitar"}
            </Txt>
          </Button>
        </section>
      </StyledContainer>
    )
  );
};

export default PrivacyCookiesPolicy;

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 440px;
  padding: 16px;
  margin-bottom: 25px;
  border-radius: 16px;
  z-index: 99999;
  background-color: ${(props) => props.config.colors.WHITE.W};
  position: fixed;
  bottom: 48px;
  left: 48px;
  flex-direction: column;
  box-shadow: 0px 4px 23.1px 2px rgba(0, 0, 0, 0.23);

  @media (max-width: ${BREAKPOINTS.PHONE_BIGGER}px) {
    left: 50%;
    transform: translateX(-50%);
    bottom: 12px;
    max-width: 330px;
  }

  .left-section {
    margin-bottom: 12px;

    .left-section-Title {
      align-items: center;
      color: ${(props) => props.config.colors.BRAND.CRUZEIRO};
      font-family: Outfit;
      font-weight: 700;
      font-style: Bold;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0%;
      text-transform: none;

      img {
        height: 20px;
        width: 20px;
      }
    }

    .left-section-message {
      font-family: Outfit;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px !important;
      margin-top: 8px;
      color: rgba(0, 0, 0, 0.64);
      line-height: 100%;
      letter-spacing: 4%;

      a {
        color: ${(props) => props.config.colors.BRAND.CRUZEIRO};
        text-decoration: underline;
      }
    }
  }

  .right-section {
    display: flex;
    gap: 16px;

    @media (max-width: ${BREAKPOINTS.PHONE_BIGGER}px) {
      gap: 8px;
      justify-content: center;
    }

    .interact-button {
      background-color: ${(props) => props.config.colors.BRAND.GOLD};
      color: ${(props) => props.config.colors.BRAND.DARK};
      border-radius: 8px;
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;

      @media (max-width: ${BREAKPOINTS.PHONE_BIGGER}px) {
        flex: ${({ open }) => open ? 'none' : 1};
      }
    }

    .right-button {
      background-color: ${(props) => props.config.colors.WHITE.W};
      border: 1px solid ${(props) => props.config.colors.BRAND.DARK};
    }

    .interact-button-text {
      white-space: nowrap;
      color: rgba(0, 42, 134, 1);
      font-family: Outfit;
      font-weight: 700;
      font-style: Bold;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0%;
      text-align: center;
      vertical-align: middle;
      text-transform: uppercase;
    }

    .btn-settings {
      padding: 8px;
      flex: none;

      img {
        height: 24px;
        width: 24px;
      }
    }
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 1em;
    height: 1em;
    text-align: center;
    line-height: 0.9em;
    border-radius: 1em;
    font-size: 30px;
    color: ${(props) => props.control?.themeLayout?.link || "#002A86"};
    cursor: pointer;
    user-select: none;
  }

  .cookie-item {
    background-color: rgba(0, 0, 0, 0.04);
    margin-top: 8px;
    padding: 12px;

    .cookie-item-title {
      color: rgba(0, 42, 134, 1);
      font-family: Outfit;
      font-weight: 600;
      font-style: SemiBold;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 4%;
      text-transform: none;
      padding-bottom: 8px;

      justify-content: space-between;
      align-items: center;

      .always-active {
        color: rgba(0, 0, 0, 0.64);
        font-size: 14px;
      }
    }

    p {
      color: rgba(0, 0, 0, 0.64);
      font-family: Outfit;
      font-weight: 400;
      font-style: Regular;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 4%;
      text-align: justify;
    }

    button {
      all: unset;
      box-sizing: border-box;
      cursor: pointer;
      background-color: rgba(0, 42, 134, 1);
      border-radius: 16px;
      padding: 2px;
      width: 36px;
      display: flex;
      justify-content: end;

      &.inactive {
        justify-content: start;
        background-color: rgba(0, 0, 0, 0.24) !important;
      }

      div {
        height: 16px;
        width: 16px;
        background-color: #fff;
        border-radius: 50%;
      }
    }
  }
`;
